import type { ReactNode } from 'react';
import { ReadOnlyContext, useReadOnly } from './read-only-context';

/*
 * Read-only mode for editing surfaces (a shared project). The field primitives honour it: text and
 * number fields become read-only inputs (still focusable and copyable), selects show their value,
 * switches, segmented controls and swatches keep their state but can't change. Actions that only
 * edit (add, remove, apply…) are wrapped in <EditOnly>.
 */

export function ReadOnlyProvider({ value, children }: { value: boolean; children: ReactNode }) {
  return <ReadOnlyContext.Provider value={value}>{children}</ReadOnlyContext.Provider>;
}

/** Renders its children only when editing is allowed (or `fallback` when it isn't). */
export function EditOnly({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  return useReadOnly() ? fallback : children;
}
